import React from 'react'

import { ShareResourceModal } from 'components/share-resource/ShareResourceModal/ShareResourceModal'
import type { SharableAgentType } from 'features/trend-detection/components/agent-sharing-calls'
import { AgentSharing } from 'features/trend-detection/components/AgentSharing/AgentSharing'

export type AgentSharingModalProps = {
  agentName: string
  agentUuid: string
  projectId: string
  isEditor: boolean
  open: boolean
  onClose: () => void
  agentType?: SharableAgentType
}

/** Thin `ShareResourceModal` wrapper around `AgentSharing` — kept at this
 * path/name/prop-shape so its four existing mount points need no changes. */
export const AgentSharingModal: React.FC<AgentSharingModalProps> = ({
  agentName,
  agentUuid,
  projectId,
  isEditor,
  open,
  onClose,
  agentType = 'issue_detection',
}) => (
  <ShareResourceModal isOpen={open} onClose={onClose} resourceName={agentName}>
    <AgentSharing
      agentUuid={agentUuid}
      projectId={projectId}
      isEditor={isEditor}
      agentType={agentType}
    />
  </ShareResourceModal>
)
